import { useBranding } from '../lib/branding';

/** The brand mark from branding/logo.svg (served by the server at /branding/logo.svg). */
export function Logo({ size = 28 }: { size?: number }) {
  const b = useBranding();
  return <img src="/branding/logo.svg" width={size} height={size} alt={b.shortName} />;
}
